import { AuthEnums } from "models/enums";
import useAPIClientHelper from "./useAPIClientHelper";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ServiceConstants } from "utils/constants";

function useGenericCommentService() {
  const { apiClientInstance } = useAPIClientHelper();

  const getGenericComments = (parentId: number, type: WintSuperkollAPIModel.GenericCommentType) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .GenericCommentClient.GetByFilter({
        ...ServiceConstants.DefaultFilter,
        parentId: parentId,
        type: type,
        orderByProperty: "Created",
        orderByDescending: true,
      })
      .then((res) => res.data);
  };

  const addGenericComment = (parentId: number, type: WintSuperkollAPIModel.GenericCommentType, newComment: string) => {
    return apiClientInstance(AuthEnums.AuthType.Company, { showErrors: true })
      .GenericCommentClient.Post({
        parentId: parentId,
        message: newComment,
        type: type,
      })
      .then((res) => res.data);
  };

  const getById = (commentId: number) => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .GenericCommentClient.GetById(commentId)
      .then((res) => res.data);
  };

  const getTopComments = () => {
    return apiClientInstance(AuthEnums.AuthType.Company)
      .GenericCommentClient.TopComments()
      .then((res) => res.data);
  };

  return { getGenericComments, addGenericComment, getById, getTopComments };
}

export default useGenericCommentService;
